module.exports = __webpack_public_path__ + "static/media/Scenario1Two.86da21da.jpg";